module.exports = __webpack_public_path__ + "static/media/HeroJellyFishDark.aab5e6f2.jpg";